"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const execute_logic_1 = __importDefault(require("../../utils/execute-logic"));
const update_model_1 = require("../../utils/update-model");
const type_conversion_1 = require("../../utils/type-conversion");
const reporter_1 = __importDefault(require("../../reporter"));
const constants_1 = require("../../constants");
const mapTypeToAttr = ({ type, modelRef: { attr = 'value' } }) => ({
    calculate: attr,
    readonly: 'readonly',
    required: 'required',
    display: 'display',
}[type]);
const executeBind = ({ bind, attr }) => models => {
    if (!bind)
        return models;
    const bindData = bind[attr];
    if (!bindData)
        return models;
    const { modelRef } = bind;
    if (Array.isArray(modelRef))
        return modelRef.reduce((acc, refN) => executeBind({ bind: { ...bind, modelRef: refN }, attr })(acc), models);
    const value = (0, execute_logic_1.default)({ ast: bindData, data: { models } });
    const modelAttr = mapTypeToAttr({ modelRef, type: attr });
    const attrsToUpdate = attr === 'calculate'
        ? { [modelAttr || constants_1.MODEL_CONTENTS]: (0, type_conversion_1.equivalentString)(value) }
        : { meta: { [modelAttr]: value } };
    return (0, update_model_1.updateModels)({
        models,
        modelRef,
        ...attrsToUpdate,
    });
};
// This function iterates over possible bind attributes and executes
// the logic for each bind attribute, returning the updated model
//
// ## Bind attrs
// modelRef: the model data this bind is referencing
// calculate: set the model data in the modelRef to the meta output
// readonly: set true or false depending on result of calculation
// relevant: set true or false depending on result of calculation
// required: set true or false depending on result of calculation
const bindAttrs = ['calculate', 'readonly', 'display', 'required'];
const executeBindAttrs = ({ bind }) => initModel => bindAttrs.reduce((model, attr) => executeBind({ bind, attr })(model), initModel);
const executeBinds = ({ binds }) => initModels => {
    reporter_1.default.perf(`Running ${binds.length} binds`);
    return binds.reduce((models, bind) => executeBindAttrs({ bind })(models), initModels);
};
exports.default = executeBinds;
//# sourceMappingURL=index.js.map